module.exports = __webpack_public_path__ + "static/media/down-carat.a63c56c5.svg";